
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useLocation } from "react-router-dom"
import { useEffect } from "react"
import ResultSuccessTickMark from "../../shared/ResultSuccessTickMark"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { showModal } from "../../../features/modal/modalSlice"
import Btn from "../../shared/button/Btn"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 600px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        p{
            font-size: 15px;
            font-weight: var(--font-weight-lg);
            text-align: center;
            line-height: 1.6;
            color: ${({ theme }) => theme.mainTextColor};
            padding: 30px 0;
        }

        .btn-container{
            display: flex;
            gap: 30px;
        }

    }
`
const AddDriverAfterVehicleQuestionModal = () => {
    const {modalLocation} = useSelector(state => state.modal)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();

         //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleClick = () => {

        dispatch(showModal("addRegularDriversVehicle"))

    }

  return (
    <Container>
        <div className="modal" onClick={(e)=> e.stopPropagation()}>
            <ResultSuccessTickMark/>
            <p>Sürücü ekleme işlemi başarı ile gerçekleştirildi. Eklediğiniz Sürücüye Araç Eklemek İster misiniz? Şimdi ekleyebilir yada sonra da ekleyebilirsiniz.</p>

            <div className="btn-container">
                <Btn width={"200px"} bgColor="#E85446" color="#fff" handleClick={handleClick}>Şimdi Ekle</Btn>
                <Btn width={"200px"} bgColor="transparent" color="#E85446" handleClick={() => dispatch(showModal(null))}>Daha Sonra</Btn>
            </div>
        </div>
    </Container>
  )
}

export default AddDriverAfterVehicleQuestionModal